/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
// import TenantHome from './Tenant_Home'
import TenantNewHome from './TenantNewHome'

const TenantWrapper: FC = () => {
  // const intl = useIntl()
  return (
    <>
      <TenantNewHome />
      {/* <TenantHome /> */}
    </>
  )
}

export default TenantWrapper
